"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var CustomerEditPageActions;
(function (CustomerEditPageActions) {
    CustomerEditPageActions["RecordAdding"] = "RecordAdding";
    CustomerEditPageActions["RecordAdded"] = "RecordAdded";
    CustomerEditPageActions["RecordDeleting"] = "RecordDeleting";
    CustomerEditPageActions["RecordDeleted"] = "RecordDeleted";
    CustomerEditPageActions["RecordLoading"] = "RecordLoading";
    CustomerEditPageActions["RecordLoaded"] = "RecordLoaded";
    CustomerEditPageActions["RecordEditing"] = "RecordEditing";
    CustomerEditPageActions["RecordEdited"] = "RecordEdited";
    CustomerEditPageActions["RecordLoadFailure"] = "RecordLoadFailure";
    CustomerEditPageActions["Cancel"] = "Cancel";
    CustomerEditPageActions["RecordDeactivated"] = "RecordDeactivated";
    CustomerEditPageActions["RecordActivated"] = "RecordActivated";
    CustomerEditPageActions["SubmissionError"] = "SubmissionError";
})(CustomerEditPageActions || (CustomerEditPageActions = {}));
exports.default = CustomerEditPageActions;
